
























































































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import moment from "moment";
import _ from "lodash";
import MyForm from "@/mixins/form";

@Component
export default class extends Mixins(MyForm) {
  @Prop() equipmentSubId!: number;

  timeType: string = "1";

  changeTimeType(e: any) {
    // console.log(e);
    this.timeType = e.target.value;
  }

  disabledDate(current: any) {
    return current < moment().subtract(1, "day").endOf("day");
  }

  handleSubmit() {
    this.form.validateFields((err: any, fieldValues: any) => {
      if (!err) {
        this.$confirm({
          title: "确认信息",
          content: "你确定要提交吗？",
          onOk: async () => {
            this.confirmLoading = true;
            const values: any = {};
            for (const key in fieldValues) {
              if (_.get(fieldValues, [key])) {
                const fieldValue = _.get(fieldValues, [key]);
                if (moment.isMoment(fieldValue)) {
                  _.set(
                    values,
                    [key],
                    moment(fieldValue).format("YYYY-MM-DD HH:mm") + ":00"
                  );
                } else if (key == "week_days") {
                  _.set(values, [key], fieldValue.join(","));
                } else {
                  _.set(values, [key], fieldValue);
                }
              }
            }
            const res = await this.$store.dispatch("equipment/taskadd", {
              equipment_sub_id: this.equipmentSubId,
              ...values,
            });
            if (res && res.Message && res.Message === "success") {
              this.$message.success(res.Message);
              this.handleCancel();
            } else {
              this.$message.error(res.Message);
            }
            this.confirmLoading = false;
          },
        });
      }
    });
  }
}
